import axios, { AxiosError } from 'axios';
import { getToken } from '@/lib/authFetch';

const PUBLIC_ENDPOINTS = ['/seller-logistics'];

export const isAxiosNetworkError = (error: Error) => {
  return error.message === 'Network Error';
};

export const makeAxiosClient = (baseURL: string) => {
  const axiosApiClient = axios.create({ baseURL });

  axiosApiClient.interceptors.request.use(async (config) => {
    // Skip token retrieval and authorization for public endpoints
    if (PUBLIC_ENDPOINTS.includes(config.url ?? '')) {
      return {
        ...config,
        headers: {
          ...config.headers,
          'Ghost-App-Type': 'marketplace',
        },
      };
    }

    const token = await getToken();

    if (!token) {
      throw new Error('No token found');
    }

    return {
      ...config,
      headers: {
        ...config.headers,
        'Ghost-App-Type': 'marketplace',
        Authorization: `Bearer ${token}`,
      },
    };
  });

  axiosApiClient.interceptors.response.use(undefined, async (error) => {
    if ((error as AxiosError).isAxiosError) {
      if (!error.response) {
        throw new Error(error.message);
      }

      if (error.response.data) {
        throw new Error(JSON.stringify(error.response.data));
      }
    }
    throw new Error(error);
  });

  // put it in the global state for use by legacy code
  globalThis.axiosApiClient = axiosApiClient;
  globalThis.axiosInitialized = true;

  return axiosApiClient;
};
